/* eslint-disable no-underscore-dangle */

import once from 'lodash/once';

import { isAnyPartOfElementInViewport } from './DOM';

const initDFP = () => {
  //
};

// export const updateBranding = cb => {
//   Array.from(document.getElementsByTagName('script')).forEach(script => {
//     if (!/a4p\.adpartner\.pro\/branding/.test(script.src)) return;
//     script.parentElement.removeChild(script);
//   });

//   const apmobhtml = document.getElementById('apmobhtml');
//   const apBrandingHtml = document.getElementById('ap_branding_html');
//   const apbranding = document.getElementById('apbranding');

//   if (apmobhtml) apmobhtml.parentElement.removeChild(apmobhtml);
//   if (apBrandingHtml) apBrandingHtml.parentElement.removeChild(apBrandingHtml);
//   if (apbranding) apbranding.style = '';

//   const div = document.createElement('div');
//   const body = document.getElementsByTagName('body')[0];
//   const script = document.createElement('script');
//   script.src = `//a4p.adpartner.pro/branding?id=7742&${Math.random()}`;
//   script.type = 'text/javascript';
//   script.async = true;
//   script.onload = cb || null;
//   div.id = 'adpartner-branding-7742';
//   div.appendChild(script);
//   body.appendChild(div);
//   console.log('updateBranding');
// };

// export const toggleHalfScreen = (show = false) => {
//   const adpartner7741 = document.getElementById('adpartner_7741');
//   if (!adpartner7741) return;
//   adpartner7741.style.display = show ? 'block' : 'none';
// };

// export const removeHalfScreen = () => {
//   Array.from(document.getElementsByTagName('script')).forEach(script => {
//     if (!/a4p\.adpartner\.pro\/media/.test(script.src)) return;
//     script.parentElement.removeChild(script);
//   });

//   const adpartner7741 = document.getElementById('adpartner_7741');
//   if (adpartner7741) adpartner7741.parentElement.removeChild(adpartner7741);
// };

// export const updateHalfScreen = cb => {
//   removeHalfScreen();
//   const body = document.getElementsByTagName('body')[0];
//   const script = document.createElement('script');
//   script.src = `//a4p.adpartner.pro/media?site_id=2370&unit_id=7741`;
//   script.type = 'text/javascript';
//   script.async = true;
//   script.onload = cb || null;
//   body.appendChild(script);
//   console.log('updateHalfScreen');
// };

export const initializeAdScripts = once(() => {
  initDFP();
});

export const refreshDFPSlots = () => {};

export const refreshVisibleDFPSlots = () => {
  if (process.env.BROWSER) {
    Array.from(document.querySelectorAll('.adBox'))
      .filter(
        el =>
          isAnyPartOfElementInViewport ||
          // If the element's display property set to 'none'
          //  match hidden nodes that are actually in the viewport by the parentNode
          (el.style.display === 'none' && isAnyPartOfElementInViewport(el.parentNode)),
      )
      .map(({ id }) => id);
  }
};
export const getAdsContext = query => {
  const {
    make,
    model,
    isMain,
    isNew,
    rubric,
    isCustomCleared,
    location,
    isCountry,
    transport,
    category,
    engine,
    dealer,
    price,
    page,
    id,
  } = query;

  const locationObj = {
    ...(isCountry && location && location.slug ? { country: location.slug } : {}),
    ...(!isCountry && location && location.slug ? { region: location.slug } : {}),
  };

  return {
    ...(transport && transport.slug ? { category: transport.slug } : {}),
    ...(category && category.slug ? { body: category.slug } : {}),
    ...(engine && engine.slug ? { fuel: engine.slug } : {}),
    ...(make && make.slug ? { make: make.slug } : {}),
    ...(model && model.slug ? { model: model.slug } : {}),
    ...(model && model.model_class && model.model_class.slug
      ? { class: model.model_class.slug }
      : {}),
    ...(rubric && rubric.slug ? { rubric: rubric.slug } : {}),
    ...(dealer && dealer.slug ? { login: dealer.slug } : {}),
    ...(price ? { price } : {}),
    ...(page ? { page } : {}),
    ...(id ? { adid: id } : {}),
    ...(isMain ? { page: 'main' } : {}),
    ...locationObj,
    ...(isNew !== undefined && isNew !== null ? { new_car: isNew ? 1 : 0 } : {}),
    ...(isCustomCleared !== undefined && isCustomCleared !== null
      ? { customs: isCustomCleared ? 1 : 0 }
      : {}),
    // need more info:
    // 'class', ''); - класс (A, B, B-High...)
  };
};

export const getPriceValuation = ({ from, to }, currency = 'uah') => {
  let course;
  if (currency === 'uah') {
    course = 1 / 26;
  } else if (currency === 'usd') {
    course = 1;
  } else if (currency === 'eur') {
    course = 26 / 32;
  }

  const usdPrice = to || from;
  let price;
  if (!course || !usdPrice) {
    return null;
  }

  if (usdPrice <= 3000) {
    price = 1;
  } else if (usdPrice <= 6000) {
    price = 2;
  } else if (usdPrice <= 7000) {
    price = 3;
  } else if (usdPrice <= 12000) {
    price = 4;
  } else if (usdPrice <= 20000) {
    price = 5;
  } else if (usdPrice <= 30000) {
    price = 6;
  } else if (usdPrice <= 40000) {
    price = 7;
  } else if (usdPrice > 50000) {
    price = 8;
  }
  if (to) {
    let priceTo = '';
    for (let a = 0, c = price; a < c; a += 1) {
      if (!priceTo) {
        priceTo = `${a + 1}`;
      } else {
        priceTo += `,${a + 1}`;
      }
    }
    return priceTo.replace(/,$/, '');
  }
  return price;
};

export const getAdsContextFromQuery = query => {
  const {
    make,
    model,
    isNew,
    rubric,
    isCustomCleared,
    location,
    isCountry,
    transport,
    category,
    engine,
    dealer,
    priceFrom,
    currency,
    page,
    id,
  } = query;

  const locationObj = {
    ...(isCountry && location ? { country: location } : {}),
    ...(!isCountry && location ? { region: location } : {}),
  };

  return {
    ...(transport ? { category: transport } : {}),
    ...(category ? { body: category } : {}),
    ...(engine ? { fuel: engine } : {}),
    ...(make ? { make } : {}),
    ...(model ? { model } : {}),
    ...(model && model.model_class && model.model_class.slug
      ? { class: model.model_class.slug }
      : {}),
    ...(page ? { page } : {}),
    ...(id ? { adid: id } : {}),
    ...(rubric ? { rubric } : {}),
    ...(dealer ? { login: dealer } : {}),
    ...(priceFrom && currency ? { price: getPriceValuation({ from: priceFrom }, currency) } : {}),
    ...locationObj,
    ...(isNew !== undefined ? { new_car: isNew } : {}),
    ...(isCustomCleared !== undefined ? { customs: isCustomCleared } : {}),
  };
};



// WEBPACK FOOTER //
// ./src/shared/helpers/adsAndMetrics.js